/**
 * A content - which was blocked - got unblocked.
 */
export const OPT_IN_CONTENT_BLOCKER = "RCB/OptIn/ContentBlocker";